<template>
    <div class="layout" :class="{'hidden-toolbar': $route.meta.hideToolbar}">
        <div class="nav_burger_section" v-if="!$route.meta.hideToolbar">
            <MenuBar></MenuBar>
        </div>
        <!-- my modal -->
        <customModalDialog :settings="customModalSettings"></customModalDialog>

        <div class="main_content_and_toolbar" :class="{admin_mode: !$route.meta.hideToolbar}">
            <ToolBar v-if="!$route.meta.hideToolbar"></ToolBar>
            <keep-alive v-if="!$route.meta.keepAlive">
                <router-view ></router-view>
            </keep-alive>
            <router-view v-else></router-view>
        </div>
    </div>
</template>

<script>
// Import plugins
import Autocomplete from 'v-autocomplete'
import 'v-autocomplete/dist/v-autocomplete.css'
// Import components
import ToolBar from '@/components/widgets/toolBar'
import mapMixin from '@/mixins/mapMixin';
import errorMixin from '@/mixins/errorMixin';
import questionMixin from '@/mixins/questionMixin';
import customModalDialog from '@/components/widgets/customModalDialog';
import MenuBar from '@/components/widgets/menuBar'
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

export default {
        name: 'mainLayout',

        mixins: [mapMixin, errorMixin, questionMixin],

        components: {
            customModalDialog,
            Autocomplete,
            ToolBar,
            MenuBar,
        },

        data() {
            return {
                customModalSettings: {},
            }
        },

        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
                makeOwnerBool: state => state.owner.makeOwnerBool,
                userInfo: state => state.auth.userInfo
            }),

            ...mapGetters({
                isUserAdmin: 'auth/isUserAdmin',
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                hasOwnOrganization: 'auth/hasOwnOrganization',
                hasOwnPlace: 'auth/hasOwnPlace',
                ownPlaces: 'auth/ownPlaces',
                getOwnPlace: 'auth/getOwnPlace',
                siteManagerPlaces: 'auth/siteManagerPlaces',
                isAddSite: 'organization/isAddSite',
                hasOrgManagerPlace: 'auth/hasOrgManagerPlace',
                orgManagerPlaces: 'auth/orgManagerPlaces',
            }),

        },

        watch: {},

        methods: {
            ...mapActions({
                searchPlaceAutocomplete: 'search/searchPlaceAutocomplete',
                updateQuestion: 'question/updateQuestion',
                fetchPlace: 'place/fetchPlace',
                createPlaceAction: 'place/createPlace',
                fetchUserInfo: 'auth/fetchUserInfo',
                addSite: 'owner/addSite'
            }),

            ...mapMutations({
                removeKeys: 'auth/removeKeys'
            }),

        },

        mounted() {

        },

        created() {
            if (this.makeOwnerBool) {
                this.$router.push({name: 'ownerBusinessFlow'})
            } else if (this.$route.meta.requiresAuth) {
                if (!this.accessToken) {
                    this.$router.push({name: 'Login', query: {redirect_url: encodeURIComponent(location.href)}})
                }
            }
        }
    }
</script>

<style scoped>
    .layout:not(.hidden-toolbar) {
        /*margin-top: 64px;*/
    }
    .layout {
        display: flex;
        flex-direction: row;
    }
    .main_content_and_toolbar {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .main_content_and_toolbar.admin_mode {
        max-height: 100vh;
    }
</style>
<style>


</style>
